var getDiscount = function getDiscount(data) {
  var _data$price, _data$price2;
  return Number(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.discount) ? "".concat(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount), "%") : undefined;
};
export default getDiscount;